var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5.328c3.453 0 6.297 2.844 6.297 6.297 0 3.479-2.844 6.297-6.297 6.297a6.296 6.296 0 0 1-6.297-6.297c0-3.453 2.818-6.297 6.297-6.297m0 1.219a5.077 5.077 0 0 0-5.078 5.078A5.06 5.06 0 0 0 12 16.703a5.077 5.077 0 0 0 5.078-5.078c0-2.793-2.285-5.078-5.078-5.078m3.555 3.326c.101.102.101.305 0 .432l-4.393 4.342a.29.29 0 0 1-.432 0L8.42 12.31c-.102-.101-.102-.304 0-.431l.584-.559a.29.29 0 0 1 .432 0l1.523 1.524 3.58-3.555c.127-.127.33-.127.432 0z"
  })));
};
export default SvgCheckCircle;